import { createSlice } from "@reduxjs/toolkit";

// This is a global state
const initialState = {
  mode: "light",
  user: null,
  token: null, //it is IdToken from aws cognito, it used to check whether user has access to api endpoints (api authorization)
  accessToken: null, // it is used to check token expiry date and time
  isShowInspection: false,
  routeList: [],
  tenantId: null,
  globalCommodity: null,
  globalMarket: null,
  isAuthenticated: false,
  lookup: null, // Add lookup to initial state to prevent undefined access
};

export const authSlice = createSlice({
  name: "auth", // auth workflow
  initialState,
  reducers: {
    // reducer is a function that modify global state
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.email = action.payload.user.email;
      state.user = action.payload.user;
      state.refreshToken = action.payload.refreshToken;
      state.token = action.payload.token;
      state.accessToken = action.payload.accessToken;
    },
    setRole: (state, action) => {
      state.role = action.payload.role;
    },
    setLogout: (state) => {
      state.user = null;
      state.refreshToken = null;
      state.token = null;
      state.accessToken = null;
      state.isShowInspection = false;
      state.routeList = null;
      state.isAuthenticated = false;
      // Clear all localStorage entries, then re-set the broadcast marker
      localStorage.clear();
      localStorage.setItem('logout', Date.now());
    },
    setRouteList: (state, action) => {
      state.routeList = action.payload;
    },
    setInspection: (state, action) => {
      state.isShowInspection = action.payload.isShowInspection;
      state.inspectionUid = action.payload.inspectionUid;
      state.assignmentUid = action.payload.assignmentUid;
    },
    setTenantId: (state, action) => {
      state.tenantId = action.payload.tenantId;
    },
    setAllowedCommodities: (state, action) => {
      state.allowedCommodities = action.payload.allowedCommodities;
    },
    setAllowedMarkets: (state, action) => {
      state.allowedMarkets = action.payload.allowedMarkets;
    },
    setAccessToken: (state, action) => {
      // state.token = action.payload.token;
      state.accessToken = action.payload.accessToken;
    },
    setLookup: (state, action) => {
      state.lookup = action.payload.lookup;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
    },
  },
});

export const { setMode, setLogin, setRole, setLogout, setInspection, setRouteList, setTenantId, 
  setAllowedCommodities, setAllowedMarkets, setAccessToken, setLookup, setIsAuthenticated
} = authSlice.actions; // Redux toolkit pattern
export default authSlice.reducer;
